// pdp-agent.js — shopping tools for AI browser agents (WebMCP, navigator.modelContext).
// In browsers that support WebMCP, an agent can read the purchasable options, pick one and
// add it to the cart through the same code path as the buttons. Elsewhere this does nothing.
// Loaded by sections/pdp-main-product.liquid when "Expose shopping tools to AI browser agents" is on.

const box = () => document.querySelector('pdp-buy-box');
const reply = (data) => ({ content: [{ type: 'text', text: JSON.stringify(data) }] });

function productJson() {
  for (const s of document.querySelectorAll('script[type="application/ld+json"]')) {
    try {
      const j = JSON.parse(s.textContent);
      if (j && j['@type'] === 'Product') return j;
    } catch (e) {
      /* not JSON */
    }
  }
  return null;
}

function productInfo() {
  const ld = productJson();
  const b = box();
  const title = document.querySelector('.pdp-title');
  const eta = document.querySelector('pdp-eta');
  return {
    name: (ld && ld.name) || (title && title.textContent.trim()) || document.title,
    url: location.href.split('#')[0],
    currency: ld && ld.offers && ld.offers[0] ? ld.offers[0].priceCurrency : undefined,
    rating: ld && ld.aggregateRating ? { value: ld.aggregateRating.ratingValue, count: ld.aggregateRating.reviewCount } : null,
    delivery_estimate: eta ? eta.textContent.trim() : null,
    options: b && typeof b.options === 'function' ? b.options() : [],
  };
}

const tools = [
  {
    name: 'get_product_options',
    description:
      "Returns this product's name, rating, delivery estimate and every purchasable option (bundle or variant) with its variant_id, quantity, price, compare-at price, availability and whether it is selected.",
    inputSchema: { type: 'object', properties: {} },
    annotations: { readOnlyHint: true },
    async execute() {
      return reply(productInfo());
    },
  },
  {
    name: 'select_option',
    description: 'Selects a purchasable option on the page by the variant_id listed by get_product_options. The shown price updates.',
    inputSchema: {
      type: 'object',
      properties: { variant_id: { type: 'string', description: 'variant_id from get_product_options' } },
      required: ['variant_id'],
    },
    async execute({ variant_id } = {}) {
      const b = box();
      if (!b || !b.selectVariant(variant_id)) return reply({ ok: false, error: 'No available option with that variant_id.' });
      return reply({ ok: true, selected: b.options().find((o) => o.selected) || null });
    },
  },
  {
    name: 'add_to_cart',
    description: 'Adds the selected option (or the option with the given variant_id) to the shopping cart and opens the cart drawer. It does not check out.',
    inputSchema: {
      type: 'object',
      properties: { variant_id: { type: 'string', description: 'Optional variant_id to select first' } },
    },
    async execute({ variant_id } = {}) {
      const b = box();
      if (!b || typeof b.add !== 'function') return reply({ ok: false, error: 'There is no buy box on this page.' });
      if (variant_id && !b.selectVariant(variant_id)) return reply({ ok: false, error: 'No available option with that variant_id.' });
      try {
        await b.add();
        return reply({ ok: true, added: b.options().find((o) => o.selected) || null, cart_url: (window.routes && window.routes.cart_url) || '/cart' });
      } catch (err) {
        return reply({ ok: false, error: String((err && err.message) || err) });
      }
    },
  },
];

const mc = navigator.modelContext;
if (mc) {
  if (typeof mc.registerTool === 'function') {
    for (const t of tools) {
      try {
        mc.registerTool(t);
      } catch (e) {
        /* already registered (theme editor re-render) */
      }
    }
  } else if (typeof mc.provideContext === 'function') {
    try {
      mc.provideContext({ tools });
    } catch (e) {
      /* unsupported shape */
    }
  }
}
